import { useCallback } from "react";

import { apiClient, StatusEnum } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const UnitOfMeasurementSelect = (props) => {
  const fetchUnitOfMeasurements = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("unit-of-measurements", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchUnitOfMeasurements}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
